/**
 * Created by Andrey Popov on 25.04.22
 */

const ThirdElementPlanner = function (slot) {
    this.slot = slot;

    this.thirdElements = this.slot.load("local_thirdelements_planner") || [];
};

ThirdElementPlanner.prototype.save = function () {
    this.slot.save("local_thirdelements_planner", this.thirdElements);
};

ThirdElementPlanner.prototype.destructor = function () {
    this.clearTimeout();
};

ThirdElementPlanner.prototype.clearTimeout = function () {
    if (this.timeout !== undefined) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
    }
};

ThirdElementPlanner.prototype.spawnPending = function () {
    if (this.thirdElements.length) {
        this.spawnLastOffer();
    }
};

ThirdElementPlanner.prototype.hasOffer = function (type) {
    return this.thirdElements.filter((offer) => offer.type === type).length;
};

ThirdElementPlanner.prototype.planNext = function (options) {
    this.thirdElements.push(options);
    this.save();

    this.clearTimeout();
    this.timeout = setTimeout(this.spawnLastOffer.bind(this), options.delay || 0);
};

ThirdElementPlanner.prototype.spawnLastOffer = function () {
    this.clearTimeout();

    if (cleverapps.focusManager.isFocused() || Map2dLocation.currentLocation.counter.isActive()) {
        return;
    }

    const options = this.thirdElements.pop();
    if (!options) {
        return;
    }

    this.save();

    const config = ThirdElement.GetConfig(options.type, options.target);
    if (!config) {
        return;
    }

    const prize = options.target || config.prize;
    const centerCell = Map2d.currentMap.getScreenCenterCell();
    const x = prize.x || centerCell.x;
    const y = prize.y || centerCell.y;

    const slot = Map2d.currentMap.findEmptySlot(x, y);
    if (slot) {
        const offer = new Unit({
            code: "thirdelement",
            stage: config.usesAd ? 0 : 1,
            type: options.type,
            prize: {
                code: prize.code,
                stage: prize.stage
            }
        });
        offer.setPosition(slot.x, slot.y);
        Map2d.currentMap.add(Map2d.LAYER_UNITS, slot.x, slot.y, offer);
        Map2d.currentMap.onAddUnit(slot.x, slot.y, offer);
        offer.findComponent(ThirdElement).onAppearance();
    }

    if (this.thirdElements.length) {
        this.timeout = setTimeout(this.spawnLastOffer.bind(this), 600);
    }
};
